import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { UpdateIndustryComponent } from './update-industry/update-industry.component'
import { CreateIndustryComponent } from './create-industry/create-industry.component'
import { IndustriesComponent } from './industries.component'
import { industriesRoutes } from './industries.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'

@NgModule({
  declarations: [
    IndustriesComponent,
    CreateIndustryComponent,
    UpdateIndustryComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(industriesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
  ],
  exports: [
    IndustriesComponent,
    CreateIndustryComponent,
    UpdateIndustryComponent,
  ],
})
export class IndustriesModule {}
